import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { AppDispatch, RootState } from "../app/store";
import { fetchBoxVideos, getBoxDetailsById, setSelectedBox } from "../features/boxSlice";
import VideoComponent from "../components/video_component";
import { getVideoPath } from "../utils/utils";
import BackButton from "../components/back_button";
import { Button } from "../styles/manage_box_page_styles";
import { useNavigate, useParams } from "react-router-dom";

// Styled components
const Container = styled.div`
  padding: 20px;
  font-family: Arial, sans-serif;
`;

const Title = styled.h1`
  text-align: center;
  color: #333;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
`;

const TableHead = styled.thead`
  background-color: #f4f4f4;
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f9f9f9;
  }
`;

const TableHeader = styled.th`
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
`;

const TableCell = styled.td`
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
`;

const LoadingRow = styled.tr`
  text-align: center;
`;

const LoadingMessage = styled.td`
  font-size: 18px;
  color: #555;
  text-align: center;
`;

const ErrorMessage = styled.div`
  text-align: center;
  font-size: 18px;
  color: red;
`;

// Styled Components
const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`;

const NoVideosMessage = styled.div`
  text-align: center;
  font-size: 18px;
  color: #777;
`;

const BoxVideosPage: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const { boxId } = useParams<{ boxId: string }>();

  const { boxVideos, boxVideosStatus, boxVideosError, selectedBox } = useSelector(
    (state: RootState) => state.boxes
  );

  useEffect(() => {
    const boxId = selectedBox?.id ?? "";
    if (boxId) {
      dispatch(fetchBoxVideos(boxId));
    }
  }, [dispatch, selectedBox]);


  useEffect(() => {

    if (selectedBox) {
      const boxId = selectedBox?.id ?? "";
      if (boxId) {
        dispatch(fetchBoxVideos(boxId));
      }
    } else {
      const idToUse = boxId;
      // Check if idToUse is a string before dispatching
      if (idToUse) {
        dispatch(getBoxDetailsById(idToUse)).unwrap()
          .then(() => {
            // dispatch(fetchBoxVideos(idToUse));
          })
          .catch((error: any) => {
            // Handle error if needed
            console.error("getBoxDetailsById  error:", error);
          });
      } else {
      }
    }

  }, [dispatch]);


  const createAllVideos = () => {
    dispatch(setSelectedBox(selectedBox));
    navigate(`/dashboard/boxes/box-all-videos/${selectedBox?.id}`);
  };

  return (
    <Container>
      <Title>{selectedBox?.name ? `${selectedBox.name} Videos` : "Box Videos"}</Title>
      <Row>
        <BackButton />
        <Button primary onClick={createAllVideos}>
          Create All Box Videos
        </Button>
      </Row>
      <Table>
        <TableHead>
          <TableRow>
            <TableHeader>Type</TableHeader>
            <TableHeader>Video</TableHeader>
          </TableRow>
        </TableHead>
        <tbody>
          {boxVideosStatus === "loading" ? (
            <LoadingRow>
              <LoadingMessage colSpan={2}>Loading...</LoadingMessage>
            </LoadingRow>
          ) : boxVideos && boxVideos.length === 0 ? (
            <LoadingRow>
              <LoadingMessage colSpan={2}>No videos found</LoadingMessage>
            </LoadingRow>
          ) : (
            boxVideos &&
            boxVideos.map((video) => (
              <TableRow key={video.id}>
                <TableCell>{video.type}</TableCell>
                <TableCell>
                  {video.status === "completed" ? (
                    <VideoComponent videoBase64={getVideoPath(video.file)} />
                  ) : (
                    <div>
                      {video.status === "processing" && <span>Video is processing...</span>}
                      {video.status === "failed" && <span>Video processing failed.</span>}
                    </div>
                  )}
                </TableCell>
              </TableRow>
            ))
          )}
        </tbody>

      </Table>
      {boxVideosStatus === "failed" && <ErrorMessage>Error: {boxVideosError}</ErrorMessage>}
    </Container>
  );
};

export default BoxVideosPage;
